import {
  deletePayment,
  getAllPayments,
  getPayment,
  newPayment,
  updatePayment,
} from '../payment-service';

export default {
  /**
   * Get all payments
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchAllPayments({ commit }, { page, limit }) {
    const response = await getAllPayments(page, limit);
    commit('setProperty', { property: 'pagination', payload: response.pagination });
    commit('setProperty', { property: 'payments', payload: response.data ? response.data : response });
  },

  /**
   *
   * @param context
   * @param payment
   * @returns {Promise<void>}
   */
  async getPayment({ commit }, { paymentId }) {
    const response = await getPayment(paymentId);
    commit('setProperty', { property: 'payment', payload: response });
  },

  /**
   *
   * @param commit
   * @param paymentId
   * @returns {Promise<void>}
   */
  async deletePayment({ commit }, { paymentId }) {
    await deletePayment(paymentId);
    commit('delProperty', { property: paymentId });
  },

  /**
   *
   * @param context
   * @param paymentId
   * @param payment
   * @returns {Promise<void>}
   */
  async updatePayment(context, { paymentId, payment }) {
    await updatePayment(paymentId, payment);
  },

  /**
   *
   * @param context
   * @param payment
   * @returns {Promise<void>}
   */
  async newPayment({ commit }, { payment }) {
    const response = await newPayment(payment);
    commit('setNewPayment', { payload: response });
    commit('setProperty', { property: 'payment', payload: response });
  },
};
